import { useState } from "react"
import "./Toggle.css"

interface ToggleProps {
  onToggle?: (selectedOption: "INDIVIDUAL" | "EN_PAREJA") => void
}

export default function ToggleNutrition({ onToggle }: ToggleProps) {
  const [isCouple, setIsCouple] = useState(false)

  const handleToggle = () => {
    const newValue = !isCouple
    setIsCouple(newValue)

    const selectedOption = newValue ? "EN_PAREJA" : "INDIVIDUAL"

    if (onToggle) {
      onToggle(selectedOption)
    }
  }

  return (
    <div className="bf-promotions-toggle-wrapper nutrition">
      <input
        type="checkbox"
        id="toggle-nutrition-checkbox"
        checked={isCouple}
        onChange={handleToggle}
        className="bf-checkbox"
      />
      <label
        htmlFor="toggle-nutrition-checkbox"
        className={`toggle-label nutrition ${isCouple ? "active" : ""}`}
      >
        <span className={`bf-individual nutrition ${isCouple ? "" : "active"}`}>Individual</span>
        <span className={`bf-couple nutrition ${isCouple ? "active" : ""}`}>En pareja</span>
      </label>
    </div>
  )
}
